import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss']
})
export class CguComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
